import ItodoImage from "../../../elements/itodo-img";
import { publicUrlFor } from "../../../../globals/constants";
import SectionCounter1 from "./section-counter1";
import { neuronMedia } from "../../../../globals/neuron-content";

function SectionAboutCompany1() {
  return (
    <div className="section-full p-t110 p-b80 sx-bg-white sx-about-bx1-outer">
      <div className="container">
        <div className="section-content">
          <div className="sx-about-bx1-content-wrap">
            <div className="row">
              <div className="col-lg-6 col-md-12 wow fadeInDown" data-wow-duration="1000ms">
                <div className="sx-about-bx1-media">
                  <div className="sx-ab-img-outer">
                    <div className="sx-ab-img-section-1-wrap"><div className="sx-ab-img-section-1" style={{ backgroundImage: `url(${publicUrlFor(neuronMedia.gallery[4])})` }} /></div>
                    <div className="sx-ab-img-section-2"><ItodoImage src={neuronMedia.banners.main} alt="security operations" /></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 wow fadeInDown" data-wow-duration="1000ms">
                <div className="sx-about-bx1-content">
                  <h2 className="sx-title">Risk mitigation with professional execution</h2>
                  <span className="sx-title-2">Bespoke protective services aligned to real operational risk.</span>
                  <p>Neuron supports organizations and individuals who need dependable security coverage for people, assets and field operations.</p>
                  <div className="progress"><div className="progress-bar sx-bg-primary" role="progressbar" style={{ width: "94%" }} aria-valuenow={94} aria-valuemin={0} aria-valuemax={100}><span>94% Operational Readiness</span></div></div>
                  <div className="row sx-about-bx1-column">
                    <div className="col-lg-6 col-md-6"><p>Close and VIP protection delivered by high-discipline operators.</p></div>
                    <div className="col-lg-6 col-md-6"><p>Field intelligence and surveillance for exposed or changing risk environments.</p></div>
                  </div>
                  <div className="row sx-about-icon-bx1-column">
                    <div className="col-lg-6 col-md-6"><div className="sx-icon-bx-2"><div className="sx-media"><i className="flaticon-mouse" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title">Protection Services</span><span className="sx-icon-bx-title-info">Close &amp; VIP</span></div></div></div>
                    <div className="col-lg-6 col-md-6"><div className="sx-icon-bx-2"><div className="sx-media"><i className="flaticon-download" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title">Consulting</span><span className="sx-icon-bx-title-info">Corporate &amp; Field</span></div></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SectionCounter1 />
        </div>
      </div>
    </div>
  );
}

export default SectionAboutCompany1;
